<template>
  <VDialog v-model="isShowModal" max-width="600" persistent>
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-pencil" class="mr-2" />
        Update Question
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VForm v-model="formValid" @submit.prevent class="mb-3 my-2">
          <VRow>
            <VCol cols="12">
              <VTextField
                v-model="form.value"
                label="Question"
                variant="outlined"
                :rules="formRules.value"
                placeholder="Enter question"
                :disabled="isLoading"
                autofocus
                :maxlength="255"
                counter
              />
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="primary" block flat @click="handleSubmit()">
                Update
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import requestsService from '@/services/requests-service/requests.service';
// Test
import { successEditQuestionText, errorEditQuestionText } from '@/text/snackbarsText';
export default {
  name: 'EditCategoryModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object
    },
    question: {
      type: Object
    },
    requestId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'saved', 'close'],

  watch: {
    question: {
      handler(newData) {
        this.form.value = newData.value;
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      isLoading: false,
      form: {
        value: this.question.value
      },
      formValid: false,
      formRules: {
        value: [(v) => !!v || 'Question required']
      }
    };
  },

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async handleSubmit() {
      if (this.formValid === true) {
        this.isLoading = true;
        try {
          const questionData = {
            value: this.form.value,
            requestId: this.requestId,
            questionId: this.question.questionId
          };
          await requestsService.updateQuestion(questionData);
          this.showSnackbar({ text: successEditQuestionText, color: 'green' });
          this.handleSuccess(this.category.categoryId, this.question.questionId, this.form.value);
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorEditQuestionText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      }
    },

    handleSuccess(categoryId, questionId, newValue) {
      this.$emit('saved', { categoryId: categoryId, questionId: questionId, newValue: newValue });
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
      this.$emit('close');
      this.resetForm();
    },

    resetForm() {
      this.form = {
        value: ''
      };
    }
  }
};
</script>
